import useId from '../utils/useId';
import * as React from 'react';
export const stopFilledSvg = React.forwardRef(function stopFilledSvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#ixxs_stopFilled__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1Z',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `ixxs_stopFilled__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M0 0h8v8H0z',
        }),
      ),
    ),
  );
});
stopFilledSvg.defaultProps = {
  width: '8',
  height: '8',
  viewBox: '0 0 8 8',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var stopFilled = {
  category: 'icon',
  colorable: true,
  name: 'stopFilled',
  svg: stopFilledSvg,
};
